import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { DicomMetadataStore } from '@ohif/core';
import { toast } from '@ohif/ui-next';
import { apiUrl } from '../../UploadDocument/apiUrl';
import { modalityMap } from './modalityMap';

// WhatsApp API (whatsapp-simple-api)
declare global { interface Window { config?: { whatsappApiUrl?: string; whatsappApiKey?: string; whatsappSession?: string } } }
const WA_API_BASE = (window?.config?.whatsappApiUrl || 'http://localhost:3001') + '/api/whatsapp';
const WA_API_KEY = window?.config?.whatsappApiKey || '';
const WA_SESSION = window?.config?.whatsappSession || 'med_session';

export default function SendLink({ instanceUid = '' }: { instanceUid?: string }) {
  const [link, setLink] = useState('');
  const [text, setText] = useState('Envio de link por WhatsApp');
  const [maxAccess, setMaxAccess] = useState(5);
  const [copied, setCopied] = useState(false);
  const [cod, setCod] = useState('591');
  const [phone, setPhone] = useState('');
  const [correo, setCorreo] = useState('');
  const [view, setView] = useState(false);
  const [rolVista, setRolVista] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sending, setSending] = useState(false);
  //instancias
  const [institutionName, setInstitutionName] = useState('');
  const [referringPhysicianName, setReferringPhysicianName] = useState('');
  const [stationName, setStationName] = useState('');
  const [performingPhysicianName, setPerformingPhysicianName] = useState('');
  const [nameOfPhysiciansReadingStudy, setNameOfPhysiciansReadingStudy] = useState('');
  const [operatorsName, setOperatorsName] = useState('');
  const [manufacturerModelName, setManufacturerModelName] = useState('');
  const [patientName, setPatientName] = useState('');
  const [protocolName, setProtocolName] = useState('');
  const [studyDate, setStudyDate] = useState('');
  const [modalities, setModalities] = useState('');
  const [description, setDescription] = useState('');
  const [qrValue, setQrValue] = useState('');
  const location = useLocation();
  useEffect(() => {
    const studyMeta = DicomMetadataStore.getStudy(instanceUid);
    if (!studyMeta?.series?.length) {
      return null;
    }
    const formatDate = dateStr => {
      if (dateStr) {
        const day = dateStr.substring(6, 8);
        const month = dateStr.substring(4, 6);
        const year = dateStr.substring(0, 4);
        return `${day}/${month}/${year}`;
      }
      return ''; // En caso de que no haya fecha
    };
    const instanceMeta = studyMeta.series[0].instances[0];
    const instanceData = {
      StudyDate: formatDate(instanceMeta.StudyDate) || '', // FECHA DEL ESTUDIO
      InstitutionName: instanceMeta.InstitutionName || '', // NOMBRE DE LA INSTITUCION
      ReferringPhysicianName: instanceMeta.ReferringPhysicianName || '', // NOMBRE DEL MEDICO QUE REFIERE
      StationName: instanceMeta.StationName || '', // NOMBRE DE LA ESTACION
      PerformingPhysicianName: instanceMeta.PerformingPhysicianName || '', // NOMBRE DEL MEDICO QUE REALIZA EL ESTUDIO
      NameOfPhysiciansReadingStudy: instanceMeta.NameOfPhysiciansReadingStudy || '', // NOMBRE DEL MEDICO QUE LEE EL ESTUDIO
      OperatorsName: instanceMeta.OperatorsName || '', // NOMBRE DEL OPERADOR
      ManufacturerModelName: instanceMeta.ManufacturerModelName || '', // MODELO DEL MANUFACTURADOR
      PatientName: instanceMeta.PatientName ? instanceMeta.PatientName[0].Alphabetic : null, // NOMBRE DEL PACIENTE
      ProtocolName: instanceMeta.ProtocolName || '', // NOMBRE DEL PROTOCOLO
    };
    setInstitutionName(instanceData.InstitutionName);
    setReferringPhysicianName(instanceData.ReferringPhysicianName);
    setStationName(instanceData.StationName);
    setPerformingPhysicianName(instanceData.PerformingPhysicianName);
    setNameOfPhysiciansReadingStudy(instanceData.NameOfPhysiciansReadingStudy);
    setOperatorsName(instanceData.OperatorsName);
    setManufacturerModelName(instanceData.ManufacturerModelName);
    setPatientName(instanceData.PatientName);
    setProtocolName(instanceData.ProtocolName);
    setStudyDate(formatDate(instanceData.StudyDate));
  }, []);
  useEffect(() => {
    if (copied) {
      toast.success('Copiado Correctamente');
    }
  });
  useEffect(() => {
    const localStr = localStorage.getItem('usuario');
    const session = localStr ? JSON.parse(localStr) : null;
    const tipoVista: string = session ? session.user.vistas : '';
    setRolVista(tipoVista.includes('LINK DE ENVIO'));
  }, []);
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const onCreate = async () => {
    try {
      // Hacer la solicitud POST al backend para crear el token
      const response = await fetch(`${apiUrl}/api/createToken`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          maxAccess: maxAccess, // maxAccess es el número de días
        }),
      });

      const data = await response.json();
      if (response.ok) {
        const token = data.token;
        const pathView = `/temporalView?StudyInstanceUIDs=` + instanceUid;
        setView(true);
        const currentUrl =
          window.location.origin + pathView + `&maxAccess=${maxAccess}&tok=${token}`;
        setLink(currentUrl);
        setQrValue(encodeURIComponent(currentUrl));
      } else {
        console.error('Error al crear el token:', data.message);
      }
    } catch (error) {
      console.error('Error al hacer la solicitud a la API:', error);
    }
  };
  const onCopy = () => {
    if (!link) {
      return alert('Primero genera el enlace.');
    }
    try {
      navigator.clipboard.writeText(link).then(() => {
        setCopied(true);
        setView(false);
        setTimeout(() => setCopied(false), 3000);
      });
    } catch {
      alert('No se pudo copiar el enlace.');
    }
  };
  const onQr = () => {
    setText('Generacion de QR');
  };
  const onWW = () => {
    setText('Envio de link por WhatsApp');
  };
  const onEmail = () => {
    setText('Envio por Correo elctronico');
  };
  const onSendWhatsApp = async () => {
    if (!link) return alert('Primero genera el enlace.');
    if (!phone) return alert('Ingrese un número de celular.');
    if (!cod) return alert('Ingrese el código de país.');

    const message = [
      referringPhysicianName ? `Hola ${referringPhysicianName}` : '',
      `Te enviamos tu estudio desde el centro medico: *${institutionName}*.`,
      `\n*Paciente:* ${patientName}`,
      `*Estudio:* ${protocolName} - ${studyDate}`,
      `*Modalidad:* ${modalities}`,
      `\n${link}`,
      `\nPara visualizarlo debe agregarnos a sus contactos.`,
      `En caso de presentar inconvenientes escríbanos a este mismo número.`,
      `\n\n*Sistema MEDSERVICE.*`,
    ].filter(Boolean).join('\n');

    setSending(true);
    try {
      // Intentar enviar por la API del bot (servidor local)
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      if (WA_API_KEY) headers['x-api-key'] = WA_API_KEY;

      const res = await fetch(`${WA_API_BASE}/messages/send`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ session: WA_SESSION, to: `+${cod}${phone}`, message }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        toast.success('Mensaje enviado por WhatsApp ');
        setView(false);
      } else {
        throw new Error(data.error || 'Error de API');
      }
    } catch (err) {
      // Fallback a wa.me si la API no está disponible
      console.warn('API no disponible, abriendo wa.me:', err);
      const encodedMessage = encodeURIComponent(message);
      window.open(`https://wa.me/${cod}${phone}?text=${encodedMessage}`, '_blank');
      setView(false);
    } finally {
      setSending(false);
    }
  };
  const onCorreoElectronico = () => {
    if (!link) {
      return alert('Primero genera el enlace.');
    }
    if (!correo) {
      return alert('Ingrese un correo electronico.');
    }
    if (!cod) {
      return alert('Ingrese un número de celular.');
    }

    // *Series:* ${description}
    const message = `
${referringPhysicianName ? `Hola ${referringPhysicianName}` : ''}
Te enviamos tu estudio desde el centro medico: *${institutionName}*.
Te enviamos tu estudio de:
\n*Paciente:* ${patientName}
*Estudio:* ${protocolName} - ${studyDate}
*Modalidad:* ${modalities}
\n${link}
\nPara visualizarlo debe agregarnos a sus contactos.
En caso de presentar inconvenientes escríbanos a este mismo número.
\n\n*Sistema MEDSERVICE.*
    `;

    const encodedMessage = encodeURIComponent(message);

    const mailtoLink = `mailto:${correo}?subject=Enlace%20de%20Sistema%20MEDSERVICE&body=${encodedMessage}`;

    setView(false);
    window.location.href = mailtoLink;
  };

  const modalOpen = () => {
    onCreate();
    setIsModalOpen(true);
  };
  return rolVista ? (
    <div className="w-full">
      <button
        // className="mx-auto mt-5 flex gap-2 px-4 py-2"
        className="hover:text-secondary-light flex h-full w-full justify-center rounded bg-transparent py-2 text-white"
        onClick={modalOpen}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          className="bi bi-share-fill h-4 w-4 sm:h-8 sm:w-8"
          viewBox="0 0 16 16"
        >
          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5" />
        </svg>
      </button>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 text-white">
          <div className="bg-primary-dark max-w-base max-h-[90vh] w-full overflow-y-auto rounded-lg p-6 pt-1 shadow-lg">
            <section className="mt-4 flex justify-between">
              <h1 className="font-bold text-white">{text}</h1>
              <button
                className="text-red-400"
                onClick={handleCloseModal}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                </svg>
              </button>
            </section>
            <section
              className={`${text === 'Envio de link por WhatsApp' ? '' : 'hidden'} mx-auto mt-4 flex h-[289px] w-[400px] flex-col justify-center justify-items-center gap-y-4 text-black`}
            >
              <div className="flex gap-2">
                <select
                  value={cod}
                  onChange={e => setCod(e.target.value)}
                  className={`w-full rounded border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400`}
                >
                  <option value="591">Bolivia</option>
                  <option value="595">Paraguay</option>
                  <option value="1">Estados Unidos</option>
                  <option value="58">Venezuela</option>
                </select>
                <input
                  type="tel"
                  placeholder="Número de celular (ej: 75212345)"
                  className={`w-full rounded border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400`}
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                />
              </div>
              <div className="flex items-center justify-center gap-2">
                <label className="text-md mb-0.5 font-bold text-white">Límite de</label>
                <input
                  type="number"
                  min={1}
                  max={10}
                  value={maxAccess}
                  onChange={e => setMaxAccess(parseInt(e.target.value, 10))}
                  className="w-16 rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="1-10"
                />
                <label className="text-md mb-0.5 font-bold text-white">días</label>
              </div>

              <button
                className={`${text === 'Envio de link por WhatsApp' ? '' : 'hidden'}hover:bg-primary-main mt-8 flex w-full items-center justify-center rounded bg-green-600 px-4 py-2 font-semibold text-white disabled:opacity-60`}
                onClick={onSendWhatsApp}
                disabled={!link || sending}
              >
                {sending ? (
                  <span className="text-sm">Enviando...</span>
                ) : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                    <span className="ml-4 text-sm text-white">Enviar enlace</span>
                  </>
                )}
              </button>
            </section>
            <section
              className={`${text === 'Envio por Correo elctronico' ? '' : 'hidden'} mx-auto mt-4 flex h-[289px] w-[400px] flex-col justify-center justify-items-center gap-y-4 text-black`}
            >
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="example@gmail.com"
                  className={`w-full rounded border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400`}
                  value={correo}
                  onChange={e => setCorreo(e.target.value)}
                />
              </div>
              <div className="flex items-center justify-center gap-2">
                <label className="text-md mb-0.5 font-bold text-white">Límite de</label>
                <input
                  type="number"
                  min={1}
                  max={10}
                  value={maxAccess}
                  onChange={e => setMaxAccess(parseInt(e.target.value, 10))}
                  className="w-16 rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="1-10"
                />
                <label className="text-md mb-0.5 font-bold text-white">días</label>
              </div>

              <button
                className={`${text === 'Envio por Correo elctronico' ? '' : 'hidden'} hover:bg-primary-main mt-8 flex w-full items-center justify-center rounded bg-green-600 px-4 py-2 font-semibold text-white`}
                onClick={onCorreoElectronico}
                disabled={!link}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="currentColor"
                  className="bi bi-envelope-at-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
                  <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
                </svg>
                <span className="ml-4 text-sm text-white">Enviar por correo electronico</span>
              </button>
            </section>
            <section
              className={`${text === 'Generacion de QR' ? '' : 'hidden'} mt-4 flex flex-col gap-y-4 text-black`}
            >
              <GenerateQR
                open={isModalOpen}
                qrValue={qrValue}
              />
            </section>

            <section className="mt-6 grid grid-cols-4 justify-center justify-items-center gap-x-6">
              <button
                onClick={onWW}
                className="hover:text-primary-dark text-primary-main flex w-full justify-center rounded-md bg-white p-2 hover:bg-gray-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="currentColor"
                  className="bi bi-whatsapp"
                  viewBox="0 0 16 16"
                >
                  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                </svg>
              </button>
              <button
                onClick={onQr}
                className="hover:text-primary-dark text-primary-main flex w-full justify-center rounded-md bg-white p-2 hover:bg-gray-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="currentColor"
                  className="bi bi-qr-code"
                  viewBox="0 0 16 16"
                >
                  <path d="M2 2h2v2H2z" />
                  <path d="M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z" />
                  <path d="M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z" />
                  <path d="M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z" />
                  <path d="M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z" />
                </svg>
              </button>
              <button
                onClick={onEmail}
                className="hover:text-primary-dark text-primary-main flex w-full justify-center rounded-md bg-white p-2 hover:bg-gray-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="currentColor"
                  className="bi bi-envelope-at-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
                  <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
                </svg>
              </button>
              <button
                onClick={onCopy}
                className="hover:text-primary-dark text-primary-main flex w-full justify-center rounded-md bg-white p-2 hover:bg-gray-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="currentColor"
                  className="bi bi-clipboard"
                  viewBox="0 0 16 16"
                >
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
                </svg>
              </button>
            </section>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div
      onClick={() => {
        toast.warning('No tiene permisos para compartir');
      }}
      className="hover:text-secondary-light flex h-full w-full justify-center rounded bg-transparent py-2 text-white"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        fill="currentColor"
        className="bi bi-eye-slash-fill"
        viewBox="0 0 16 16"
      >
        <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
        <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
      </svg>
    </div>
  );
}
function GenerateQR({ open, qrValue }: { open: boolean; qrValue: string }) {
  console.log(qrValue);
  if (!open) {
    return null;
  }
  const handleDownload = () => {
    const canvas = document.getElementById('qr-canvas') as HTMLCanvasElement;
    if (canvas) {
      const imageUrl = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = imageUrl;
      a.download = 'qr-code.png';
      a.click();
    } else {
      console.error('No se pudo encontrar el canvas');
    }
  };

  return (
    <>
      <section className="mt-4 flex items-center justify-center">
        <QRCodeCanvas
          id="qr-canvas"
          value={qrValue}
          size={200}
        />
      </section>
      <div className="flex items-center justify-center">
        <button
          onClick={handleDownload}
          className="mt-4 flex gap-x-1 rounded bg-blue-700 px-4 py-2 text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            className="bi bi-arrow-down-square text-white"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"
            />
          </svg>
          Descargar QR
        </button>
      </div>
    </>
  );
}
